var {AmpersandApp: productCatalogApp, AmpersandView} = require('catalog/libs');

var HPEConstants = require('../../../base/hpe.constants');

var template = require('../templates/hpe.productlist.pagination.template.tpl');

/**
 * Product Listing Pagination view
 */
module.exports = AmpersandView.extend({

    template: template,

    /**
     * bindings
     */
    bindings: {
        'model.previousDisabled': [
            {
                type: 'booleanClass',
                hook: 'previous',
                name: 'disabled'
            },
            {
                type: 'attribute',
                hook: 'previous',
                name: 'aria-disabled'
            }
        ],
        'model.nextDisabled': [
            {
                type: 'booleanClass',
                hook: 'next',
                name: 'disabled'
            },
            {
                type: 'attribute',
                hook: 'next',
                name: 'aria-disabled'
            }
        ],
        'model.labelPagination': {
            type: 'text',
            hook: 'pagination-label'
        },
        'model.labelPrevious': {
            type: 'text',
            selector: '.pagination-list-previous span'
        },
        'model.labelNext': {
            type: 'text',
            selector: '.pagination-list-next span'
        }
    },

    /**
     * events
     */
    events: {
        'click .pagination-list-previous': 'onPrevious',
        'click .pagination-list-next': 'onNext'
    },

    /**
     * handle clicks to next page
     * @param  {object} e event object
     */
    onNext: function(e) {
        e.preventDefault();
        productCatalogApp.trigger(HPEConstants.catalog.VIEW_UPDATE_REQUEST, {
            'type': 'pagination',
            'value': this.model.nextPage
        });
    },

    /**
     * handle clicks to previous page
     * @param  {object} e event object
     */
    onPrevious: function(e) {
        e.preventDefault();
        productCatalogApp.trigger(HPEConstants.catalog.VIEW_UPDATE_REQUEST, {
            'type': 'pagination',
            'value': this.model.previousPage
        });
    }
});

